<template>
	<transition 
			appear
			:appear-active-class="$_index_stylePageAnimation()">
		<template v-if="initialized_">
			<v-container
					:class="$_index_infoIsFluidPage ? 'customVContainer fluid' : 'customVContainer'"
					:style="$_index_stylePageContainerStyle()"
					fluid>
				<template v-if="$_index_infoShowPageTitle">
					<page-title-layout
							:inits="$_index_inits()" />
				</template>
				<template v-if="!$_index_infoHidePageContents">
					<template v-if="$_index_statePageType() == 'alert'">
						<alert-layout
								:contents="$_index_contents()"
								:inits="$_index_inits()" />
					</template>
					<template v-if="$_index_statePageType() == 'banner'">
						<banner-layout
								:contents="$_index_contents()"
								:inits="$_index_inits()" />
					</template>
					<template v-if="$_index_statePageType() == 'calendar'">
						<calendar-layout
								:contents="$_index_contents()"
								:inits="$_index_inits()" />
					</template>
					<template v-if="$_index_statePageType() == 'card'">
						<card-layout
								:contents="$_index_contents()"
								:inits="$_index_inits()" />
					</template>
					<template v-if="$_index_statePageType() == 'carousel'">
						<carousel-layout
								:contents="$_index_contents()"
								:inits="$_index_inits()" />
					</template>
					<template v-if="$_index_statePageType() == 'csvStepper'">
						<csv-stepper-layout
								:contents="$_index_contents()"
								:inits="$_index_inits()" />
					</template>
					<template v-if="$_index_statePageType() == 'dataTable'">
						<data-table-layout
								:contents="$_index_contents()"
								:inits="$_index_inits()" />
					</template>
					<template v-if="$_index_statePageType() == 'expansionPanel'">
						<expansion-panel-layout
								:contents="$_index_contents()"
								:inits="$_index_inits()" />
					</template>
					<template v-if="$_index_statePageType() == 'iframe'">
						<iframe-layout
								:contents="$_index_contents()"
								:inits="$_index_inits()" />
					</template>
					<template v-if="$_index_statePageType() == 'input'">
						<input-layout
								:contents="$_index_contents()"
								:inits="$_index_inits()" />
					</template>
					<template v-if="$_index_statePageType() == 'inputWithStepper'">
						<input-with-stepper-layout
								:contents="$_index_contents()"
								:inits="$_index_inits()" />
					</template>
					<template v-if="$_index_statePageType() == 'sheet'">
						<sheet-layout
								:contents="$_index_contents()"
								:inits="$_index_inits()" />
					</template>
					<template v-if="$_index_statePageType() == 'slideGroup'">
						<slide-group-layout
								:contents="$_index_contents()"
								:inits="$_index_inits()" />
					</template>
					<template v-if="$_index_statePageType() == 'stepper'">
						<stepper-layout
								:contents="$_index_contents()"
								:inits="$_index_inits()" />
					</template>
					<template v-if="$_index_statePageType() == 'tab'">
						<tab-layout
							:contents="$_index_contents()"
							:inits="$_index_inits()" />
					</template>				
					<template v-if="$_index_statePageType() == 'treeview'">
						<treeview-layout
							:contents="$_index_contents()"
							:inits="$_index_inits()" />
					</template>
					<template v-if="$_index_statePageType() == 'window'">
						<window-layout
							:contents="$_index_contents()"
							:inits="$_index_inits()" />
					</template>
					<!-- for recruit -->
					<template v-if="$_index_statePageType() == 'recruitInput'">
						<recruit-input-layout
								:contents="$_index_contents()"
								:inits="$_index_inits()" />
					</template>
					<!-- for training -->
					<template v-if="$_index_statePageType() == 'trainingInput'">
						<training-test-input-layout
							:contents="$_index_contents()"
							:inits="$_index_inits()" />
					</template>
				</template>
			</v-container>
		</template>
		<template v-else>
			<v-row class="customVRow">
				<v-col cols="12" class="center">
					<progress-circular />
				</v-col>
			</v-row>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'Index',
		data() {
			return {
				pageName_: 'index',
				pageType_: 'default',

				initialized_: false
			}
		},
		computed: {
			// params
			$_index_params() {
				const self_ = this;
				const route_ = self_.$route
				return route_.params
			},
			$_index_paramsPageName() {
				const self_ = this;
				const params_ = self_.$_index_params;
				if(self_.isFalse(params_)) { return null }
				return self_.convertCaseToCamel(params_.pageName)
			},
			$_index_paramsPageType() {
				const self_ = this;
				const params_ = self_.$_index_params;
				if(self_.isFalse(params_)) { return null }
				return self_.convertCaseToCamel(params_.pageType)
			},
			// state
			$_index_statePageName() {
				const self_ = this;
				return () => {
					return self_.getPageState('name')
				}
			},
			$_index_statePageType() {
				const self_ = this;
				return () => {
					return self_.getPageState('type')
				}
			},
			$_index_statePageIsInitialized() {
				const self_ = this;
				const initialized_ = self_.getPageState('isInitialized')
				return initialized_[self_.$_index_statePageName()]
			},
			// contents / inits
			$_index_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getPageContents(self_.$_index_statePageName())
					if(self_.$_index_statePageName() == 'dummy') {
						return contents_
					} else {
						return self_.getContentsSubset(contents_, 'isDummy', false)
					}
				}
			},
			$_index_inits() {
				const self_ = this;
				return () => {
					return self_.getPageInits(self_.$_index_statePageName())
				}
			},
			// info
			$_index_infoIsFluidPage() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_index_inits(), 'isFluidPage')
			},
			$_index_infoShowPageTitle() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_index_inits(), 'showPageTitle')
			},
			$_index_infoHidePageContents() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_index_inits(), 'hidePageContents')
			},
			$_index_infoContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_index_inits(), 'contact')
			},
			// style
			$_index_stylePage() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_index_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_index_inits(), 'page')
				}
			},
			$_index_stylePageAnimation() {
				const self_ = this;
				return () => {
					const page_ = self_.$_index_stylePage()
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.animation)
				}
			},
			$_index_stylePageContainer() {
				const self_ = this;
				if(self_.isEmpty(self_.$_index_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_index_inits(), 'pageContainer')
			},
			$_index_stylePageContainerStyle() {
				const self_ = this;
				return () => {
					const page_ = self_.$_index_stylePageContainer;
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.style)
				}
			}
		},
		watch: {
			$route() { this.$_index_updateRoute() }
		},
		created() {
			const self_ = this;
			// page name & page type
			self_.$_index_setPageState()
			// life cycle
			const pageName_ = self_.$_index_statePageName()
			const pageType_ = self_.$_index_statePageType()
			self_.createdPage(pageName_ + ' (template type: ' + pageType_ + ')')
			// page initialization
			if(self_.$_index_statePageIsInitialized) { 
				self_.initialized_ = true;
			} else { 
				self_.$_index_initialize()
			}
		},
		beforeMount() {
			const self_ = this;
			const pageName_ = self_.$_index_statePageName()
			self_.beforeMountPage(pageName_)
		},
		beforeDestroy() {
			const self_ = this;
			const pageName_ = self_.$_index_statePageName()
			self_.beforeDestroyPage(pageName_)
		},
		methods: {
			$_index_setPageState() {
				const self_ = this;
				// set page name & type
				let name_ = null;
				let type_ = null;
				if(self_.isEmpty(self_.$_index_params)) { 
					name_ = self_.pageName_;
					type_ = self_.pageType_;
				} else if(self_.isFalse(self_.$_index_paramsPageName) || self_.isFalse(self_.$_index_paramsPageType)) {
					name_ = 'dummy';
					type_ = 'default';
				} else {
					name_ = self_.$_index_paramsPageName;
					type_ = self_.$_index_paramsPageType;
				}
				self_.setPageState('name', name_)
				self_.setPageState('type', type_)
			},
			$_index_initialize() {
				const self_ = this;

				const pageName_ = self_.$_index_statePageName()
				const pageType_ = self_.$_index_statePageType()

				Promise.resolve().then(() => {
					return self_.initializePage(pageName_, pageType_)
				}).then(() => {
					self_.initialized_ = true;
				}).catch(error => {
/* error */			self_.logError('Error', '$_index_initialize()', error)
				})
			},
			$_index_updateRoute() {
				const self_ = this;
				// set page name & type
				self_.$_index_setPageState()
				// life cycle
				const pageName_ = self_.$_index_statePageName()
				const pageType_ = self_.$_index_statePageType()
				self_.updatePage(pageName_ + ' (template type: ' + pageType_ + ')')
				// page initialization
				self_.initialized_ = false;

				const initialized_ = self_.getPageState('isInitialized')
				const init_ = initialized_[pageName_]
				if(self_.isFalse(init_) || pageName_ == 'dummy') {
					self_.$_index_initialize()
				} else {
					self_.initialized_ = true;
				}
			}
		}
	}
</script>

<style scoped>
</style>